import * as types from '../mutationTypes'
const state = {
  userId: '',
  userName: '',
  userPhone: '',
  aesEcbPhone: '',
  enCodePhone: '', // 加密的手机号,给在线客服带参用的
  isLogin: 0,
  openId: ''
}

const mutations = {
  // 设置所有的用户信息
  [types.SET_USER_INFO] (state, payload) {
    Object.keys(payload).forEach(key => {
      state[key] = payload[key]
    })
  },
  // 设置用户名
  [types.SET_USER_NAME] (state, payload) {
    state.userName = payload
  },
  // 设置用户电话
  [types.SET_USER_PHONE] (state, payload) {
    state.userPhone = payload
  },
  // 设置用户登陆状态
  [types.SET_LOGIN_STATUS] (state, payload) {
    state.isLogin = payload
  },
  // 设置用户openId,携带在在线客服链接后面
  [types.SET_SERVER_OPENID] (state, payload) {
    state.openId = payload
  }
}

const actions = {
  setUserInfo ({ commit }, userInfo) {
    commit(types.SET_USER_INFO, userInfo)
  },
  setUserName ({ commit }, userName) {
    commit(types.SET_USER_NAME, userName)
  },
  setUserPhone ({ commit }, userPhone) {
    commit(types.SET_USER_PHONE, userPhone)
  },
  setLoginStatus ({ commit }, isLogin) {
    commit(types.SET_LOGIN_STATUS, isLogin)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
